import { InteractionUpdateInput } from '@api/generated/graphql';
import { updateInteractionByChannelIdV2 } from './updateInteractionMethods';
import extractErrorMessage from '@lib/utils/extractErrorMessage';

// Only accept fields that should be sent from the frontend.
// Fields like channel, from, to, tenantId, etc. are handled by the backend via Kafka events
// and should not be sent from the frontend to avoid conflicts.
// Status is also managed by backend - frontend should not send it.
export type UpdateInteractionByChannelIdInput = Pick<
  InteractionUpdateInput,
  | 'agentNotes'
  | 'channelClassification'
  | 'contacts'
  | 'customerId'
  | 'customerName'
>;

const updateInteractionByChannelId = async (
  channelId: string,
  tenantId: string | undefined,
  input: UpdateInteractionByChannelIdInput,
) => {
  try {
    return await updateInteractionByChannelIdV2(channelId, tenantId, input);
  } catch (err) {
    throw new Error(extractErrorMessage(err));
  }
};

export default updateInteractionByChannelId;
